/*eslint-disable*/ import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import makeStyles from '@mui/styles/makeStyles';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
// @mui/icons-material
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import Favorite from "@mui/icons-material/Favorite";
// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
// sections for this page
import SectionText from "pages-sections/blog-post/2020/10/fake-reviews/SectionText.js";
import SectionBlogInfo from "pages-sections/blog-post/2020/10/fake-reviews/SectionBlogInfo.js";
import SectionComments from "pages-sections/blog-post/SectionComments.js";
import SectionSimilarStories from "pages-sections/blog-post/2020/10/fake-reviews/SectionSimilarStories.js";


import blogPostPageStyle from "styles/jss/nextjs-material-kit-pro/pages/blogPostPageStyle.js";

const useStyles = makeStyles(blogPostPageStyle);

export const metadata = {
  title: "An analysis of the Fake Reviews Problem - Tribalism",
  date: "2020-10-01",
  summary: "We are an Australian Digital Marketing Agency based in Melbourne. In this blog, we take a look at how some companies get fake reviews written to boost their ratings. Fake reviews... we all know they exist. We all know it's a problem - but do we really understand its scale? Should we be worried about how much fake reviews are delegitimizing the online economy?",
  image: "/img/posts/2020-10-01-FakeReviews/baliphotos20-min.webp",
  url: "https://www.tribalism.com.au/blog-post/2020/10/the-fake-reviews-economy",
  author: "Scott Sunderland",
};


export default function BlogPostPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();
  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.png" 
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        title="An analysis of the Fake Reviews Problem - Tribalism"
        image="/img/posts/2020-10-01-FakeReviews/baliphotos20-min.webp"
        url="https://www.tribalism.com.au/blog-post/2020/10/the-fake-reviews-economy"
        type="article"
        description="We are an Australian Digital Marketing Agency based in Melbourne. In this blog we take a look at how some companies get fake reviews written to boost their ratings."

        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />
      <Parallax image="/img/posts/2020-10-01-FakeReviews/baliphotos20-min.webp" filter="dark">
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem md={8} className={classes.textCenter}>
              <h1 className={classes.title}>
              Fake Reviews...
              </h1>
              <h4 className={classes.subtitle}>
                Fake reviews... we all know they exist. We all know its a problem - but do we really understand its scale? Should we be worried about how much fake reviews are delegitimising the online econmomy?
              </h4>
              <br />
              <Button color="rose" size="lg" href="#start" round>
                <FormatAlignLeft /> Read Article
              </Button>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classes.main}>
        <div className={classes.container}>
          <SectionText />
          <SectionBlogInfo />
          <SectionComments />
        </div>
      </div>
      <SectionSimilarStories />
      <Footer
        content={
          <div>
            <div className={classes.left}>
              <List className={classes.list}>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href="https://www.creative-tim.com/?ref=njsmkp-blog-post"
                    target="_blank"
                    className={classes.block}
                  >
                    Creative Tim
                  </a>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href="https://www.creative-tim.com/presentation?ref=njsmkp-blog-post"
                    target="_blank"
                    className={classes.block}
                  >
                    About us
                  </a>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href="https://blog.creative-tim.com/?ref=njsmkp-blog-post"
                    target="_blank"
                    className={classes.block}
                  >
                    Blog
                  </a>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href="https://www.creative-tim.com/license?ref=njsmkp-blog-post"
                    target="_blank"
                    className={classes.block}
                  >
                    Licenses
                  </a>
                </ListItem>
              </List>
            </div>
            <div className={classes.right}>
              &copy; {1900 + new Date().getYear()} , made with{" "}
              <Favorite className={classes.icon} /> by{" "}
              <a
                href="https://www.creative-tim.com?ref=njsmkp-blog-post"
                target="_blank"
              >
                Creative Tim
              </a>{" "}
              for a better web.
            </div>
          </div>
        }
      />
    </div>
  );
}
